import { render, staticRenderFns } from "./ChatMaintenancePanel.vue?vue&type=template&id=392f446c&scoped=true&"
import script from "./ChatMaintenancePanel.vue?vue&type=script&lang=ts&"
export * from "./ChatMaintenancePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392f446c",
  null
  
)

export default component.exports